<template>
  <div class="home">
    <section class="section columns" id="top-banner">
      <div class="column columns is-vcentered" id="carousel-container">
        <carousel-3d
          class="column"
          :controls-visible="true"
          :autoplay="true"
          :autoplay-timeout="5000"
          :display="1"
          :perspective="1"
          :height="450"
          :width="600"
        >
          <slide :index="0">
            <figure class="image"></figure>
            <img src="@/assets/images/athena_carousel_01.jpg" />
          </slide>
          <slide :index="1">
            <img src="@/assets/images/athena_carousel_02.jpg" />
          </slide>
          <slide :index="2">
            <img src="@/assets/images/athena_carousel_03.jpg" />
          </slide>
          <slide :index="3">
            <img src="@/assets/images/athena_carousel_04.jpg" />
          </slide>
          <slide :index="4">
            <img src="@/assets/images/athena_carousel_05.jpg" />
          </slide>
          <slide :index="5">
            <img src="@/assets/images/athena_carousel_06.jpg" />
          </slide>
          <slide :index="6">
            <img src="@/assets/images/athena_carousel_07.jpg" />
          </slide>
          <slide :index="7">
            <img src="@/assets/images/athena_carousel_08.jpg" />
          </slide>
          <slide :index="8">
            <img src="@/assets/images/athena_carousel_09.jpg" />
          </slide>
          <slide :index="9">
            <img src="@/assets/images/athena_carousel_10.jpg" />
          </slide>
          <slide :index="10">
            <img src="@/assets/images/athena_carousel_11.jpg" />
          </slide>
          <slide :index="11">
            <img src="@/assets/images/athena_carousel_12.jpg" />
          </slide>
          <slide :index="12">
            <img src="@/assets/images/athena_carousel_13.jpg" />
          </slide>
        </carousel-3d>
      </div>
      <div class="column columns is-vcentered" id="banner-heading">
        <div class="column">
          <!-- <h1>Athena Consulting</h1> -->
          <img
            src="../assets/images/athena_logo_triangle_2000.png"
            alt="Athena Consulting | Where Wisdom Wins"
            width="50%"
            height="auto"
          />
          <h3 class="is-size-2-touch">Where Wisdom Wins</h3>
          <p>
            The need for customized human capital solutions amongst diverse
            business sectors globally has never been greater. Winners are those
            who are wise enough to acknowledge that the only differentiator is
            People. Athena Consulting is dedicated to provide single-window
            cutting-edge Human Capital Management solutions & services. We
            design human capital management processes, acquire and develop
            talent using intensive learning and development initiatives, manage
            tend-to-end employee life-cycle management through our
            employee-leasing services. One of our major focus areas is to create
            a safe, inclusive, diverse, and harassment-free workplace.
          </p>
        </div>
      </div>
    </section>
    <section class="section" id="athena-values">
      <div class="container columns">
        <HomeCard
          title="Experience"
          text="Our founders have over 30 years’ experience in working with both MNC’s and Indian firms across a wide range of industries. Our team of young Management Graduates brings in the necessary understanding of today’s and tomorrow’s business. Our wide-ranging network of associates aid us in providing the best possible services to our clients."
          icon="far fa-lightbulb"
          class="column"
        />
        <HomeCard
          title="Methodology"
          text="Athena helps you by providing not only what you want, but also what you need. We assess an extensive number of HR and organizational parameters with a view to comprehensively understand our clients’ requirements. Our knowledgeable and efficient team of professionals go all out in order to comprehend the client’s organization, its aims, principles, and culture. We consider ourselves to be a part of the client’s organization in order to provide customized services with utmost quality."
          icon="fas fa-cogs"
          class="column"
        />
        <HomeCard
          title="Solutions"
          text="Athena specializes in the full spectrum of HR services that fulfil all needs of the organization. Athena’s Human Capital Consulting (HCC) practice provides a wide range of human capital management products and services covering acquisition, management, development & out placement, designed to help organizations address these challenges and succeed together. We provide extensive services in the area of inclusive culture building, prevention of sexual harassment and bullying at the workplace."
          icon="fas fa-heartbeat"
          class="column"
        />
      </div>
    </section>
    <section class="hero" id="offerings-hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-3-touch">
            Our Offerings
          </h1>
        </div>
      </div>
    </section>
    <section class="section" id="athena-offerings">
      <div class="container columns">
        <HomeCard
          title="Talent Acquisition Services"
          text="Athena offers talent search and selection services at leadership and executive levels. We attract the right talent across diverse industries and deliver services around the globe at a speedy rate of execution."
          icon="fas fa-search"
          class="column"
        />
        <HomeCard
          title="Learning & Development Initiatives"
          text="Athena offers sustainable solutions in the area of learning and development services to assist organizations overcome business challenges to meet their unique objectives. Our programs are designed to help bridge gaps in the area of attitude, skill & knowledge variances impacting the realization of full potential of the client’s Human Capital."
          icon="fas fa-book"
          class="column"
        />
        <HomeCard
          title="Culture, Diversity & POSH Advisory"
          text="Creating a culture of inclusivity, respect and safety at workplaces is an on-going movement. We enable organizations to lay a strong foundation for safe workplaces in consonance with the Sexual Harassment of Women (Prevention, Prohibition and Redressal) Act, 2013. Our approach is to assist organizations truly embrace the culture or Diversity, inclusivity and respect that makes its people truly proud to belong."
          icon="fas fa-bullhorn"
          class="column"
        />
      </div>
      <div class="container columns">
        <HomeCard
          title="Recruitment Process Outsourcing"
          text="Athena assumes the role of the client company’s internal recruitment cell. We manage the complete hiring process, from job profiling to on-boarding new hires, within the framework of the client's policies, need & cultural fit."
          icon="fas fa-filter"
          class="column"
        />
        <HomeCard
          title="Employee Leasing & Staffing"
          text="Skilled contractual workforce is one of the biggest challenges that the industries face today. Our Employee leasing is designed to make skilled workforce available in bulk. We take care of the total employee lifecycle management of our on roll employees, deputed to the client organisation with 100% compliance."
          icon="fas fa-exchange-alt"
          class="column"
        />
        <HomeCard
          title="HR Process Management"
          text="Our HR Process Management is aimed at taking over the total HR operations of the client company with embedded Human Resources. This includes placing of ace HR professionals at the clients premise with HR Project Management advisory."
          icon="fas fa-sync-alt"
          class="column"
        />
      </div>
      <div class="container columns">
        <HomeCard
          title="Human Capital Consulting"
          text="Athena helps the client organization to revise and revamp their existing HR policies so that they become more focused, employee-centric, responsive & cost-effective. Athena works closely with the client, understanding the client’s business strategies and organizational requirements, devising multiple customized solutions, and helping the client organization to implement these strategies."
          icon="fas fa-compass"
          class="column"
          style="margin-right: 70px"
        />
        <div class="column"></div>
        <div class="column"></div>
      </div>
    </section>
    <section class="section container is-hidden-touch" id="athena-testimonials">
      <carousel-3d
        class="column"
        :controls-visible="true"
        :autoplay="false"
        :autoplay-timeout="10000"
        :display="1"
        :perspective="0"
        :width="1000"
      >
        <slide :index="0">
          <p class="is-size-3-desktop is-size-5-touch">
            "Quick understanding of the client requirements was most of the time
            backed up by quick mapping of comparator organizations and its key
            people to help us get the best available talent from the market."
          </p>
          <div class="testimonial-client is-size-6-touch is-size-5-desktop">
            Subhayu Basu, Director: Human Resources, Jupiter Capital
          </div>
        </slide>
        <slide :index="1">
          <p class="is-size-3-desktop is-size-5-touch">
            "The ability of the Athena Recruitment Team to comprehend &
            appreciate the business realities of our industry and to source
            talent in line with the organization requirements has made the
            entire engagement process very smooth & successful."
          </p>
          <div class="testimonial-client is-size-6-touch is-size-5-desktop">
            Sujoy Banerjee, President - Group HR & OD, McNally Bharat
            Engineering Company Ltd
          </div>
        </slide>
        <slide :index="2">
          <p class="is-size-3-desktop is-size-5-touch">
            "Athena blends HR in a subtle way where people and technology works
            together. A firm believer of embracing the concept of talent
            branding."
          </p>
          <div class="testimonial-client is-size-6-touch is-size-5-desktop">
            Amit Kr Sarkar, Albert David Limited
          </div>
        </slide>
        <slide :index="3">
          <p class="is-size-3-desktop is-size-5-touch">
            "I highly recommend Athena Consulting to any organization looking
            for HR outsourcing and training provider without reservation."
          </p>
          <div class="testimonial-client is-size-6-touch is-size-5-desktop">
            Mahmoud Al Mamari, Assistant Training Manager, Abraj Energy Services
            S.A.O.C.
          </div>
        </slide>
        <slide :index="4">
          <p class="is-size-3-desktop is-size-5-touch">
            "We are happy to mention the timely recruitment support from Athena
            so far with the positions in drilling operations for Abraj Energy
            Services S.A.O.C."
          </p>
          <div class="testimonial-client is-size-6-touch is-size-5-desktop">
            Sunny Thomas, Head of Personnel, Abraj Energy Services S.A.O.C.
          </div>
        </slide>
      </carousel-3d>
    </section>
  </div>
</template>

<script>
import HomeCard from "@/components/HomeCard.vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "home",
  components: {
    HomeCard,
    Carousel3d,
    Slide,
  },
};
</script>
